import { Component, ElementRef, AfterViewInit, input, output, viewChild, signal } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { isUndefined } from 'lodash';
import { iOS, Android } from '@libs/helper/helper';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@libs/stand-alone-components/commons/icon/icon.component';
import { debounceTime, map } from 'rxjs';

@Component({
  selector: 'app-email-input',
  styleUrls: ['./email-input.scss'],
  templateUrl: `./email-input.html`,
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],

  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, IconComponent],
})
export class EmailInputComponent implements AfterViewInit {
  onenter = output<string>();
  emailInput = viewChild<ElementRef>('focus');
  focusOnStart = input<boolean>();
  iOS = signal(iOS());
  android = signal(Android());
  isValid$;
  constructor(private parentF: FormGroupDirective) {}
  ngAfterViewInit() {
    this.isValid$ = this.ctrl.valueChanges.pipe(
      debounceTime(500),
      map(() => this.ctrl.valid),
    );
    if (!isUndefined(this.focusOnStart())) this.emailInput().nativeElement.focus();
  }
  onPressEnter() {
    this.valid && this.onenter.emit(this.ctrl.value);
  }
  get ctrl() {
    return this.parentF.form?.controls['email'];
  }
  get valid() {
    return this.ctrl.valid;
  }
}
